module.exports = __webpack_public_path__ + "img/7.2068f7df.png";